/**
 * Notification Type Formatter.
 *
 * @param {*} value
 * @param {*} row
 *
 * @returns {*}
 */
window.notificationTypeFormatter = function(value, row) {
    let html = '';
    switch (row.type) {
        case "App\\Notifications\\Monitoring\\Task\\Failed":
            html += __('Monitoring');
            break;
        case "App\\Notifications\\Domains\\Statistics\\Report":
            html += __('Domain Statistics');
            break;
        default:
            html += __('Not Implemented');
            break;
    }
    return html;
};
